export var DEPRECATED_TIMEZONES = {
    'US/Eastern': 'America/New_York',
    'US/Central': 'America/Chicago',
    'US/Mountain': 'America/Denver',
    'US/Pacific': 'America/Los_Angeles',
    'US/Alaska': 'America/Anchorage',
    'US/Hawaii': 'Pacific/Honolulu',
    UTC: 'Etc/UTC',
};
export var DEFAULT_TIMEZONES = ['Etc/UTC', 'UTC'];
export var INVALID_DATE = 'Invalid date';
export var ABSOLUTE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
